/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_UnsubscribeInputs */

const id_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti Berlangganan`)
};

const ms_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berhenti Langgan`)
};

const da_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afmeld`)
};

const de_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

const en_us2_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

const es_es2_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desuscribirse`)
};

const es_mx2_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar suscripción`)
};

const fil_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-unsubscribe`)
};

const fr_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se désabonner`)
};

const it_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla iscrizione`)
};

const hu_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leiratkozás`)
};

const nl_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitschrijven`)
};

const no_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld av`)
};

const pl_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wypisz się`)
};

const pt_br2_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

const pt_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar subscrição`)
};

const ro_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezabonare`)
};

const fi_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta tilaus`)
};

const sv_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avsluta prenumeration`)
};

const vi_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy đăng ký`)
};

const tr_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelikten çık`)
};

const cs_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odhlásit odběr`)
};

const bg_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отписване`)
};

const ru_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отписаться`)
};

const uk_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відписатися`)
};

const ar_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء الاشتراك`)
};

const hi_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन रद्द करें`)
};

const th_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิกการสมัคร`)
};

const ja_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購読解除`)
};

const zh_cn2_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

const zh_hant1_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

const ko_notifications_push_unsubscribe = /** @type {(inputs: Notifications_Push_UnsubscribeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독 취소`)
};

/**
* | output |
* | --- |
* | "Unsubscribe" |
*
* @param {Notifications_Push_UnsubscribeInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_unsubscribe = /** @type {((inputs?: Notifications_Push_UnsubscribeInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_UnsubscribeInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_unsubscribe(inputs)
	if (locale === "ms") return ms_notifications_push_unsubscribe(inputs)
	if (locale === "da") return da_notifications_push_unsubscribe(inputs)
	if (locale === "de") return de_notifications_push_unsubscribe(inputs)
	if (locale === "en-US") return en_us2_notifications_push_unsubscribe(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_unsubscribe(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_unsubscribe(inputs)
	if (locale === "fil") return fil_notifications_push_unsubscribe(inputs)
	if (locale === "fr") return fr_notifications_push_unsubscribe(inputs)
	if (locale === "it") return it_notifications_push_unsubscribe(inputs)
	if (locale === "hu") return hu_notifications_push_unsubscribe(inputs)
	if (locale === "nl") return nl_notifications_push_unsubscribe(inputs)
	if (locale === "no") return no_notifications_push_unsubscribe(inputs)
	if (locale === "pl") return pl_notifications_push_unsubscribe(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_unsubscribe(inputs)
	if (locale === "pt") return pt_notifications_push_unsubscribe(inputs)
	if (locale === "ro") return ro_notifications_push_unsubscribe(inputs)
	if (locale === "fi") return fi_notifications_push_unsubscribe(inputs)
	if (locale === "sv") return sv_notifications_push_unsubscribe(inputs)
	if (locale === "vi") return vi_notifications_push_unsubscribe(inputs)
	if (locale === "tr") return tr_notifications_push_unsubscribe(inputs)
	if (locale === "cs") return cs_notifications_push_unsubscribe(inputs)
	if (locale === "bg") return bg_notifications_push_unsubscribe(inputs)
	if (locale === "ru") return ru_notifications_push_unsubscribe(inputs)
	if (locale === "uk") return uk_notifications_push_unsubscribe(inputs)
	if (locale === "ar") return ar_notifications_push_unsubscribe(inputs)
	if (locale === "hi") return hi_notifications_push_unsubscribe(inputs)
	if (locale === "th") return th_notifications_push_unsubscribe(inputs)
	if (locale === "ja") return ja_notifications_push_unsubscribe(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_unsubscribe(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_unsubscribe(inputs)
	return ko_notifications_push_unsubscribe(inputs)
});
export { notifications_push_unsubscribe as "notifications.push.unsubscribe" }